import { render, staticRenderFns } from "./unreadTopics.vue?vue&type=template&id=551f159c"
import script from "./unreadTopics.vue?vue&type=script&lang=js"
export * from "./unreadTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('551f159c')) {
      api.createRecord('551f159c', component.options)
    } else {
      api.reload('551f159c', component.options)
    }
    module.hot.accept("./unreadTopics.vue?vue&type=template&id=551f159c", function () {
      api.rerender('551f159c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/topbar/unreadTopics.vue"
export default component.exports